import {
  ModalContainer,
  ModalTitle,
  TextArea,
  TextInput,
} from '@medeloop/medeloop-components-library';
import { ChangeEvent, useRef, useState } from 'react';

type SaveCohortModalProps = {
  onClose: () => void;
  onSave: ({ name, description }: { name: string; description: string }) => void;
  onSkip: () => void;
  name: string | null;
  description: string | null;
};

export const SaveCohortModal = ({
  onClose,
  onSave,
  onSkip,
  name,
  description,
}: SaveCohortModalProps) => {
  // Use refs to track if user has interacted with the fields
  const hasUserEditedName = useRef(false);
  const hasUserEditedDescription = useRef(false);
  
  // Initialize state only once with props, then let user control it
  const [nameValue, setName] = useState(() => name || '');
  const [descriptionValue, setDescription] = useState(() => description || '');

  const handleName = (e: ChangeEvent<HTMLInputElement>) => {
    hasUserEditedName.current = true;
    setName(e.target.value);
  };

  const handleDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
    hasUserEditedDescription.current = true;
    setDescription(e.currentTarget.value);
  };

  const handleSave = () => {
    const trimmedName = nameValue.trim();
    if (!trimmedName) {
      return; // Don't save if name is empty
    }
    onSave({
      name: trimmedName,
      description: descriptionValue.trim(),
    });
  };

  return (
    <ModalContainer className="flex flex-col" onClose={onClose}>
      <ModalTitle> Name and describe your cohort </ModalTitle>

      <div className="flex flex-col gap-4">
        <TextInput value={nameValue} label="Cohort name" onChange={handleName} />
        <TextArea
          value={descriptionValue}
          label="Cohort description"
          onChange={handleDescription}
        />
      </div>
      <div className="flex justify-end gap-4 mt-4">
        <button
          className="w-[76px] rounded-full border border-cool-gray-600 flex items-center justify-center px-4 py-2"
          onClick={onSkip}
        >
          Skip
        </button>

        <button
          className="bg-primary-background-default hover:bg-primary-background-hover text-black font-medium px-4 py-2 rounded-full text-md border border-stroke-on-dark-subdued disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleSave}
          disabled={!nameValue.trim()}
        >
          Save and Continue
        </button>
      </div>
    </ModalContainer>
  );
};
